var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-view',{attrs:{"name":"header"}}),_c('main',[_c('fade-transition',{attrs:{"origin":"center","mode":"out-in","duration":250}},[_c('router-view')],1)],1),_c('router-view',{attrs:{"name":"footer"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }